<template>
  <div class="w100">
    <div class="w100 pb10 cl-f">
      <div class="fr">
        用户名：
        <el-input class="mr20" style="width: 200px;" v-model="searchText" @keyup.enter.native="fetchList" placeholder="可输入关键字查询"></el-input>
        <el-button type="primary" @click="page = 1, fetchList()">查询</el-button>
        <el-button type="warning" :loading="searching" @click="showAddView" v-if="hasEditRole">新增</el-button>
        <el-button @click="delRole()" v-if="hasEditRole">删除</el-button>
      </div>
    </div>
    <el-table class="w100 tx-c my-table" :data="list" stripe border height="550" @selection-change="changeListSelect">
      <el-table-column align="center" type="selection" width="55" :selectable="hasSel" v-if="hasEditRole"></el-table-column>
      <el-table-column align="center" label="序号" width="80">
        <template slot-scope="scope">
          <span>{{ ((page - 1) * size) + scope.$index + 1 }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="姓名" prop="userName"></el-table-column>
      <el-table-column align="center" label="学号/工号" prop="userId"></el-table-column>
      <el-table-column align="center" label="部门" prop="departmentName"></el-table-column>
      <el-table-column align="center" label="授权人">
        <template slot-scope="scope">
          <span v-if="scope.row.creator">{{ scope.row.creator + '(' + scope.row.creatorId + ')' }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="授权人部门" prop="creatorDeptName"></el-table-column>
    </el-table>

    <div class="w100 mt20 tx-r">
      <el-pagination @size-change="changeSize" @current-change="changePage" :current-page="page" :page-sizes="[5, 30, 50, 100]" :page-size="size" layout="total, sizes, prev, pager, next, jumper" background :total="total"></el-pagination>
    </div>

    <el-dialog :visible.sync="isShow" :close-on-click-modal="!updataing" :close-on-press-escape="!updataing" :show-close="!updataing" width="1000px">
      <span class="font-16" slot="title">新增人员</span>
      <div class="w100">
        <div class="w100 mb20 flex-box" v-if="siftData.length > 0">
          <SiftComp class="flex-1" ref="sift" :sift-data="siftData" :loading="updataing" @click-search="fetchData" />
          <div class="">
            <el-button type="primary" @click="fetchData" :loading="searching">查询</el-button>
          </div>
        </div>
        <el-table class="w100 tx-c my-table" :data="listNew" stripe border @selection-change="changeListSelecNew">
          <el-table-column align="center" type="selection" width="55"></el-table-column>
          <el-table-column align="center" label="序号" width="80">
            <template slot-scope="scope">
              <span>{{ ((page - 1) * size) + scope.$index + 1 }}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="姓名" prop="userName"></el-table-column>
          <el-table-column align="center" label="学号/工号" prop="userId"></el-table-column>
          <el-table-column align="center" label="部门" prop="departmentName"></el-table-column>
        </el-table>

        <div class="w100 mt20 tx-r">
          <el-pagination @current-change="changePageNew" :current-page="pageNew" :page-size="sizeNew" layout="total, prev, pager, next, jumper" background :total="totalNew"></el-pagination>
        </div>
      </div>
      <span slot="footer">
        <el-button @click="isShow = false" :loading="updataing">取 消</el-button>
        <el-button type="primary" :loading="updataing" @click="addRole">添 加</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
import SiftComp from "@/components/CompSift/SiftComp";

export default {
  name: "OfficeRoleUser",
  components: {
    SiftComp
  },
  props: ["select-role", "get-url"],
  data() {
    return {
      loading: false,
      searchText: "",
      page: 1,
      size: 30,
      total: 0,
      list: [],
      listSelect: [],

      hasEditRole: false,

      isShow: false,
      searching: false,
      siftData: [],
      pageNew: 1,
      sizeNew: 10,
      totalNew: 0,
      listNew: [],
      listSelectNew: [],

      updataing: false
    };
  },
  computed: {
    ...mapState(["userData"])
  },
  created() {},
  mounted() {},
  methods: {
    fetchEditRole() {
      this.addGCD();

      this.$http
        .post(
          `userRole/hasEditRole`,
          this.$qs.stringify({
            roleId: this.selectRole
          })
        )
        .then(({ data }) => {
          // console.log(data.resData);
          if (data.resStatus == 0 && data.resCode == 0) {
            this.hasEditRole = data.resData;
            this.fetchList();
            this.fetchSiftData();
          } else {
            this.$message({
              message: data.resMsg,
              type: "error"
            });
          }
          this.reduceGCD();
        })
        .catch(() => {
          this.$message({
            message: "网络请求错误，请检查网络",
            type: "error"
          });
          this.reduceGCD();
        });
    },
    fetchSiftData() {
      this.siftData = [];
      this.searching = true;

      this.$http
        .post(`userRole/getCondition`, this.$qs.stringify({}))
        .then(({ data }) => {
          // console.log(data.resData);
          if (data.resStatus == 0 && data.resCode == 0) {
            this.siftData = data.resData.siftData;
          } else {
            this.$message({
              message: data.resMsg,
              type: "error"
            });
          }
          this.searching = false;
        })
        .catch(() => {
          this.$message({
            message: "网络请求错误，请检查网络",
            type: "error"
          });
          this.searching = false;
        });
    },
    fetchData() {
      this.listNew = [];

      let obj = {};
      for (const i in this.siftData) {
        obj = this.$refs.sift.clickSearchBtn();
      }
      obj.roleId = this.selectRole;
      obj.pageNum = this.pageNew;
      obj.pageSize = this.sizeNew;
      this.searching = true;
      // console.log(obj);

      this.$http
        .post(`userRole/getAddList`, this.$qs.stringify(obj))
        .then(({ data }) => {
          // console.log(data.resData);
          if (data.resStatus == 0 && data.resCode == 0) {
            this.listNew = data.resData.list;
            this.totalNew = data.resData.total;
          } else {
            this.$message({
              message: data.resMsg,
              type: "error"
            });
          }
          this.searching = false;
        })
        .catch(() => {
          this.$message({
            message: "网络请求错误，请检查网络",
            type: "error"
          });
          this.searching = false;
        });
    },
    fetchList() {
      this.addGCD();

      this.$http
        .post(
          this.getUrl,
          this.$qs.stringify({
            roleId: this.selectRole,
            queryKey: this.searchText,
            pageNum: this.page,
            pageSize: this.size
          })
        )
        .then(({ data }) => {
          // console.log(data.resData);
          if (data.resStatus == 0 && data.resCode == 0) {
            this.list = data.resData.list;
            this.total = data.resData.total;
          } else {
            this.$message({
              message: data.resMsg,
              type: "error"
            });
          }
          this.reduceGCD();
        })
        .catch(() => {
          this.$message({
            message: "网络请求错误，请检查网络",
            type: "error"
          });
          this.reduceGCD();
        });
    },
    addRole() {
      // console.log(this.listSelectNew);
      if (!this.listSelectNew.length) {
        this.$message({
          message: `请至少选择一条数据提交`,
          type: "error"
        });
        return;
      }
      const obj = this.listSelectNew.map(val => {
        return {
          roleId: this.selectRole,
          userId: val.userId,
          deptId: val.departmentId
        };
      });

      this.addGCD();

      this.$http
        .post("userRole/add", JSON.stringify(obj), {
          headers: {
            "Content-Type": "application/json;charset=utf-8"
          }
        })
        .then(({ data }) => {
          // console.log(data.resData);
          if (data.resStatus == 0 && data.resCode == 0) {
            this.$message({
              message: data.resMsg,
              type: "success"
            });
            this.fetchList();
          } else {
            this.$message({
              message: data.resMsg,
              type: "error"
            });
          }
          this.isShow = false;
          this.reduceGCD();
        })
        .catch(() => {
          this.$message({
            message: "网络请求错误，请检查网络",
            type: "error"
          });
          this.isShow = false;
          this.reduceGCD();
        });
    },
    delRole() {
      if (!this.listSelect.length) {
        this.$message({
          message: `请至少选择一条数据提交`,
          type: "error"
        });
        return;
      }

      this.$confirm("是否移除选中人员", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          const obj = this.listSelect.map(val => {
            return {
              id: val.id,
              creatorId: val.creatorId
            };
          });

          this.addGCD();

          this.$http
            .post("userRole/delete", JSON.stringify(obj), {
              headers: {
                "Content-Type": "application/json;charset=utf-8"
              }
            })
            .then(({ data }) => {
              // console.log(data.resData);
              if (data.resStatus == 0 && data.resCode == 0) {
                this.$message({
                  message: data.resMsg,
                  type: "success"
                });
                this.fetchList();
              } else {
                this.$message({
                  message: data.resMsg,
                  type: "error"
                });
              }
              this.reduceGCD();
            })
            .catch(() => {
              this.$message({
                message: "网络请求错误，请检查网络",
                type: "error"
              });
              this.reduceGCD();
            });
        })
        .catch(() => {});
    },
    hasSel(row) {
      // console.log(row);
      if (row.userName.indexOf("(兼任)") > -1) {
        return true;
      } else {
        return false;
      }
    },
    showAddView() {
      this.isShow = true;
      this.$nextTick(() => {
        this.fetchData();
      });
    },
    changeListSelect(value) {
      this.listSelect = value;
    },
    changeListSelecNew(value) {
      this.listSelectNew = value;
    },
    addGCD() {
      this.$emit("add-gcd");
    },
    reduceGCD() {
      this.$emit("reduce-gcd");
    },
    changeSize(value) {
      this.size = value;
      this.fetchList();
    },
    changePage(value) {
      this.page = value;
      this.fetchList();
    },
    changePageNew(value) {
      this.pageNew = value;
      this.fetchData();
    }
  },
  watch: {
    selectRole(value) {
      this.searchText = "";
      this.page = 1;
      this.pageNum = 1;
      this.fetchEditRole();
    }
  }
};
</script>

<style scoped>
</style>
